import React, { useEffect, useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, MenuItem, Select, FormControl,
    InputLabel, RadioGroup, FormControlLabel, Radio,
    Checkbox
} from "@mui/material";
import BASE_URL, { COMMUNITYADMINS } from "../../NetworkConfig/ApiConfig";

const SpaceNoticeboardReplacePopup = ({ open, onClose, slideData, onSuccess = () => { } }) => {

    const formatDateTimeLocal = (date) => {
        if (!date) return "";

        const d = new Date(date);

        if (isNaN(d.getTime())) return "";

        const pad = (num) => String(num).padStart(2, "0");

        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };

    const [formData, setFormData] = useState({
        community: slideData.community ?? null,
        title: slideData.title.toString(),
        description: slideData.description.toString(),
        mediaUrl: null, // image to upload
        redirectUrl: slideData.redirectUrl.toString(), // https URL
        redirectType: slideData.redirectType.toString(), // outside/inside
        redirectId: slideData.redirectId.toString(), // event ID if any
        idType: slideData.idType.toString(), // type (Event or empty)
        endTime: formatDateTimeLocal(slideData.downTime)
    });

    const [notifyUsers, setNotifyUsers] = useState(false)

    useEffect(() => {
        setFormData({
            community: slideData.community ?? null,
            title: slideData.title.toString(),
            description: slideData.description.toString(),
            mediaUrl: null, // image to upload
            redirectUrl: slideData.redirectUrl.toString(), // https URL
            redirectType: slideData.redirectType.toString(), // outside/inside
            redirectId: slideData.redirectId.toString(), // event ID if any
            idType: slideData.idType.toString(), // type (Event or empty)
            endTime: formatDateTimeLocal(slideData.downTime)
        })
    }, [slideData._id])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setFormData((prev) => ({ ...prev, mediaUrl: e.target.files[0] }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("redirectUrl", formData.redirectUrl);
        data.append("redirectType", formData.redirectType === "none" ? "outside" : formData.redirectType);
        data.append("redirectId", formData.redirectId);
        data.append("idType", formData.idType);
        data.append("notify", `${notifyUsers}`)

        // Ensure mediaUrl is a File object before appending
        if (formData.mediaUrl instanceof File) {
            data.append("media", formData.mediaUrl);
        } else {
            console.warn("mediaUrl is not a valid file");
        }

        if (formData.endTime) {
            data.append(
                "endTime",
                new Date(formData.endTime).toISOString()
            );
        } else {
            data.append("endTime", "");
        }


        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${BASE_URL}/community/noticeboard/update/${slideData._id}`, {
                method: "PUT",
                headers: {
                    "auth-token": token,  // ✅ Do NOT set Content-Type manually
                },
                body: data
            });

            const json = await response.json();
            console.log(json);

            if (json.success === true) {
                alert("Noticeboard updated successfully!");
                onSuccess()
            } else {
                alert(`${json.response}`);
            }

        } catch (error) {
            console.error("Submission error:", error);
            alert("Error sharing data in noticeboard!");
        }
    };


    return (
        <Dialog open={open} onClose={onClose} >
            <DialogTitle style={{ background: "#202020", fontFamily: "poppins-mid" }}>Add To Noticeboard</DialogTitle>
            <DialogContent style={{ background: "#202020" }}>
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <TextField fullWidth margin="dense" label="Noticeboard title..." name="title" value={formData.title} onChange={handleChange} required
                        sx={{
                            fontSize: "14px",
                            "& .MuiInputLabel-root": {
                                color: "#ffffff90",
                                fontFamily: "poppins-reg",  // Change label font family
                            },
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": { borderColor: "#ffffff20", borderRadius: "10px" },
                                "&:hover fieldset": { borderColor: "#ffffff20", borderRadius: "10px" },
                                "&.Mui-focused fieldset": { borderColor: "#ffffff20", borderRadius: "10px" },
                            },
                            "& .MuiInputBase-input": {
                                fontFamily: "poppins-reg", // Change font family
                                fontSize: "14px", // Change font size
                            },
                        }}
                    />
                    <TextField fullWidth margin="dense" label="Description" name="description" value={formData.description} onChange={handleChange} multiline rows={3}
                        sx={{
                            fontSize: "14px",
                            "& .MuiInputLabel-root": {
                                color: "#ffffff90",
                                fontFamily: "poppins-reg",  // Change label font family
                            },
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                "&:hover fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                "&.Mui-focused fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                            },
                            "& .MuiInputBase-input": {
                                fontFamily: "poppins-reg", // Change font family
                                fontSize: "14px", // Change font size
                            },
                        }} />


                    {/* Redirect Type (Inside/Outside) */}
                    <FormControl component="fieldset" margin="dense">
                        <RadioGroup row name="redirectType" value={formData.redirectType} onChange={handleChange}>
                            <FormControlLabel
                                value="inside"
                                control={<Radio sx={{
                                    color: "#ffffff90", // Default color
                                    "&.Mui-checked": {
                                        color: "white", // Selected color
                                    },
                                }} />}
                                label="Open Inside"
                                sx={{
                                    "& .MuiTypography-root": {
                                        fontSize: "14px", // Change font size
                                        fontFamily: "poppins-reg", // Change font family
                                        color: "#ffffff", // Change font color
                                    },
                                }}
                            />
                            <FormControlLabel
                                value="outside"
                                control={<Radio sx={{
                                    color: "#ffffff90", // Default color
                                    "&.Mui-checked": {
                                        color: "white", // Selected color
                                    },
                                }} />}
                                label="Open Outside"
                                sx={{
                                    "& .MuiTypography-root": {
                                        fontSize: "14px",
                                        fontFamily: "poppins-reg",
                                        color: "#ffffff",
                                    },
                                }}
                            />

                            <FormControlLabel
                                value="none"
                                control={<Radio sx={{
                                    color: "#ffffff90", // Default color
                                    "&.Mui-checked": {
                                        color: "white", // Selected color
                                    },
                                }} />}
                                label="Do nothing"
                                sx={{
                                    "& .MuiTypography-root": {
                                        fontSize: "14px",
                                        fontFamily: "poppins-reg",
                                        color: "#ffffff",
                                    },
                                }}
                            />
                        </RadioGroup>
                    </FormControl>

                    {
                        formData.redirectType == "outside" && (
                            <TextField fullWidth margin="dense" label="Redirect URL" name="redirectUrl" value={formData.redirectUrl} onChange={handleChange} type="url"
                                sx={{
                                    fontSize: "14px",
                                    "& .MuiInputLabel-root": {
                                        color: "#ffffff90",
                                        fontFamily: "poppins-reg",  // Change label font family
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                        "&:hover fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                        "&.Mui-focused fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                    },
                                    "& .MuiInputBase-input": {
                                        fontFamily: "poppins-reg", // Change font family
                                        fontSize: "14px", // Change font size
                                    },
                                }} />
                        )
                    }

                    {
                        formData.redirectType == "inside" && (
                            <TextField fullWidth margin="dense" label="Redirect Id or event Id" name="redirectId" value={formData.redirectId} onChange={handleChange}
                                sx={{
                                    fontSize: "14px",
                                    "& .MuiInputLabel-root": {
                                        color: "#ffffff90",
                                        fontFamily: "poppins-reg",  // Change label font family
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                        "&:hover fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                        "&.Mui-focused fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                    },
                                    "& .MuiInputBase-input": {
                                        fontFamily: "poppins-reg", // Change font family
                                        fontSize: "14px", // Change font size
                                    },
                                }} />
                        )
                    }

                    {
                        formData.redirectType == "inside" && (
                            <TextField fullWidth margin="dense" label="ID Type (Event or Empty)" name="idType" value={formData.idType} onChange={handleChange}
                                sx={{
                                    fontSize: "14px",
                                    "& .MuiInputLabel-root": {
                                        color: "#ffffff90",
                                        fontFamily: "poppins-reg",  // Change label font family
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                        "&:hover fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                        "&.Mui-focused fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                    },
                                    "& .MuiInputBase-input": {
                                        fontFamily: "poppins-reg", // Change font family
                                        fontSize: "14px", // Change font size
                                    },
                                }} />
                        )
                    }

                    <TextField
                        fullWidth
                        margin="dense"
                        label="End Time"
                        name="endTime"
                        type="datetime-local"
                        value={formData.endTime}
                        onChange={handleChange}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        helperText="This slide will disappear after the selected time. Leave empty to not auto remove."
                        sx={{
                            fontSize: "14px",

                            "& .MuiInputLabel-root": {
                                color: "#ffffff90",
                                fontFamily: "poppins-reg",
                            },

                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    borderColor: "#ffffff40",
                                    borderRadius: "10px",
                                },
                                "&:hover fieldset": {
                                    borderColor: "#ffffff40",
                                    borderRadius: "10px",
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#ffffff40",
                                    borderRadius: "10px",
                                },
                            },

                            "& .MuiInputBase-input": {
                                fontFamily: "poppins-reg",
                                fontSize: "14px",
                                color: "#ffffff",
                            },

                            "& .MuiFormHelperText-root": {
                                color: "#ffffff70",
                                fontFamily: "poppins-reg",
                                fontSize: "11px",
                                marginLeft: "0px",
                            },

                            "& input::-webkit-calendar-picker-indicator": {
                                filter: "invert(1)",
                                cursor: "pointer",
                            },
                        }}
                    />


                    {/* File Upload */}
                    <input type="file" accept="image/*" onChange={handleFileChange} style={{ marginTop: "10px", fontFamily: "poppins-reg", width: "100%" }} />

                    <FormControlLabel
                        control={
                            <Checkbox checked={notifyUsers} sx={{
                                color: '#aaa',
                                '&.Mui-checked': {
                                    color: '#4caf50', // your custom color when checked
                                },
                            }} onChange={() => {
                                setNotifyUsers(!notifyUsers)
                            }} />
                        }

                        sx={{
                            marginTop: "20px",
                            fontFamily: "poppins-reg"
                        }}
                        label="Send notification to community?"
                    />

                    <DialogActions>
                        <Button onClick={onClose} style={{ fontFamily: "poppins-reg", color: "#ffffff" }}>Cancel</Button>
                        <Button type="submit" style={{ fontFamily: "poppins-reg", color: "#ffffff", background: "#706dea" }} variant="contained">Replace</Button>
                    </DialogActions>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default SpaceNoticeboardReplacePopup;
